import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOwnership } from '@core/debug';
import { factory, Modal as PlasmaModal } from '@coveord/plasma-mantine';
export var Modal = factory(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), backendOwner = _ref2.backendOwner, framework = _ref2.framework, frontendOwner = _ref2.frontendOwner, props = _object_without_properties(_ref2, [
        "backendOwner",
        "framework",
        "frontendOwner"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    useOwnership({
        backendOwner: backendOwner,
        framework: framework,
        frontendOwner: frontendOwner,
        invisible: !props.opened
    });
    return /*#__PURE__*/ _jsx(PlasmaModal, _object_spread({
        ref: ref
    }, props));
});
var ModalRoot = factory(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), backendOwner = _ref2.backendOwner, framework = _ref2.framework, frontendOwner = _ref2.frontendOwner, props = _object_without_properties(_ref2, [
        "backendOwner",
        "framework",
        "frontendOwner"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    useOwnership({
        backendOwner: backendOwner,
        framework: framework,
        frontendOwner: frontendOwner,
        invisible: !props.opened
    });
    return /*#__PURE__*/ _jsx(PlasmaModal.Root, _object_spread({
        ref: ref
    }, props));
});
Modal.Root = ModalRoot;
Modal.Body = PlasmaModal.Body;
Modal.Overlay = PlasmaModal.Overlay;
Modal.Content = PlasmaModal.Content;
Modal.Header = PlasmaModal.Header;
Modal.Title = PlasmaModal.Title;
Modal.CloseButton = PlasmaModal.CloseButton;
Modal.Footer = PlasmaModal.Footer;
Modal.Stack = PlasmaModal.Stack;

//# sourceMappingURL=Modal.js.map